import { forwardRef } from 'react';

import { useForkRef, useMeasure } from '@spazious/react-hooks';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

import { StickyProvider, StickyProviderProps } from './StickyProvider.js';

export interface StickyContainerProps
  extends OverrideProps<FlexProps, Pick<StickyProviderProps, 'id' | 'children'>> {}

export const StickyContainer = forwardRef<FlexElement, StickyContainerProps>(
  ({ children, id, ...restProps }, ref) => {
    const [setContainerElem, container] = useMeasure<FlexElement>();

    const forkedRef = useForkRef(ref, setContainerElem);

    return (
      <StickyProvider container={container} id={id}>
        <Flex ref={forkedRef} {...restProps}>
          {children}
        </Flex>
      </StickyProvider>
    );
  }
);
